import { useEffect } from 'react';

type UseNavigationKeywordsProps = {
  shortcutsDisabled: boolean;
  handleClickNextUi: () => void;
  handleClickPrevUi: () => void;
};

export const useNavigationKeywords = ({
  shortcutsDisabled,
  handleClickNextUi,
  handleClickPrevUi,
}: UseNavigationKeywordsProps) => {
  const hadleNextUi = (event: KeyboardEvent) => {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      handleClickNextUi();
    }
  };

  const handlePrevUi = (event: KeyboardEvent) => {
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      handleClickPrevUi();
    }
  };

  const handleKeywords = (event: KeyboardEvent) => {
    const target = event.target as HTMLElement;

    const isActiveElementContentEditable = target.isContentEditable;

    const isActiveElementAnInput = ['INPUT', 'TEXTAREA', 'SELECT'].includes(
      document.activeElement?.tagName || ''
    );

    const isInputFocused = isActiveElementAnInput || isActiveElementContentEditable;

    if (isInputFocused) return;

    if (shortcutsDisabled) return;

    // Do not execute if Control (or Cmd on Mac) is pressed
    if (event.ctrlKey || event.metaKey) return;

    // Alt+Arrow is handled by the body-level keyboard listener; skip here to avoid double navigation
    if (event.altKey) return;

    hadleNextUi(event);
    handlePrevUi(event);
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeywords);
    return () => {
      document.removeEventListener('keydown', handleKeywords);
    };
  }, [handleKeywords]);
};
